<template>
  <div>
    <h6 class="text-success" :style="{visibility: totalCounts > 0 ? 'visible' : 'hidden'}">
      {{solutions > 0 ? 'Solution found' : 'No solution found yet'}}
      {{ solutions > 0 ? `1 in ${averageCount} picks` : `0 in ${totalCounts} picks`}}
      {{ solutions > 0 ? `(${averagePercent} %)` : ''}}
    </h6>
    <div class="mr-3 tt--solutions-count">
      <p>
        <span style="font-size: 115%;" class="badge badge-dark">{{ solutions }}</span> Solutions
      </p>
      <p>
        <span style="font-size: 115%;" class="badge badge-dark">{{ totalCounts }}</span> Count
      </p>
      <p>(Includes duplicates and symmetries)</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["solutions", "totalCounts"],
  computed: {
    averageCount() {
      if (this.solutions > 0) {
        return (this.totalCounts / this.solutions).toFixed(2);
      }
      return 0;
    },
    averagePercent() {
      if (this.solutions > 0) {
        return Number(((this.solutions / this.totalCounts) * 100).toFixed(2));
      }
      return 0;
    },
  },
};
</script>

<style scoped>
</style>